import { Injectable } from '@angular/core';
import io from 'socket.io-client';
import { environment } from '../../environments/environment';
import { catchError, switchMap, take } from 'rxjs/operators';
import { BehaviorSubject, Observable, Observer, of } from 'rxjs';
import { AccountService } from './account.service';

@Injectable({
    providedIn: 'root'
})
export class SocketService {
    private socket: any;
    private url: string = environment.socketUrl;

    private _connected$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    get connected$(): Observable<boolean> {
        return this._connected$.asObservable();
    }
    set connected(value: boolean) {
        if (this._connected$.value === value) {
            return;
        }
        this._connected$.next(value);
    }

    constructor(private account: AccountService,) {
        this.account.isAuthenticated$.subscribe(isAuthenticated => {
            if (isAuthenticated) {
                this.connect();
            } else {
                this.disconnect();
            }
        })
    }

    connect() {
        this.account.updateTokenV2().pipe(
            take(1),
            switchMap(session => {
                if (!session) {
                    return null;
                }

                if (!this.socket || !this.socket.connected) {
                    this.socket = io(`${this.url}?token=${session}`);
                    console.log('SocketIO::CONNECT');
                }

                this.connected = true;
                return of(this.socket);
            }),
            catchError(err => {
                throw err;
            })
        ).subscribe();
    }

    disconnect(): void {
        if (this.socket && this.socket.connected) {
            console.log('SocketIO::DISCONNECT');
            this.socket.disconnect();
            this.connected = false;
        }
    }

    sendMessage(route: string, message: any): void {
        console.log('SocketIO::SEND::' + route, message);
        this.socket.emit(route, JSON.stringify(message));
    }

    onMessage(route: string): Observable<any> {
        return new Observable((observer: Observer<any>) => {
            this.socket.on(route, (data: any) => {
                console.log('SocketIO::RECEIVED::' + route, JSON.parse(data));
                observer.next(data);
            });
        });
    }
}
